import React from "react";
import HeroSection from '../components/HeroSection';
import CategorySection from '../components/CategorySection';
import FeaturedBusinesses from '../components/FeaturedBusinesses';
import CategoriesAndNewsSection from '../components/CategoriesAndNewsSection';
import RecentFirmsAndEventsSection from '../components/RecentFirmsAndEventsSection';

const HomePage = ({ setCurrentPage, setSelectedCategory }) => {
  return (
    <div>
      <HeroSection setCurrentPage={setCurrentPage} />
      <CategorySection
  setCurrentPage={setCurrentPage}
setSelectedCategory={setSelectedCategory}/>
      <FeaturedBusinesses setCurrentPage={setCurrentPage}/>
      <CategoriesAndNewsSection setCurrentPage={setCurrentPage}/> 
      <RecentFirmsAndEventsSection setCurrentPage={setCurrentPage}/>
    </div>
  );
};

export default HomePage;